/**
 * @file ErrorBoundary.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Show this Ui if any error crash happen in app.
 */
import React, { Component } from "react";
import { Typography, Container, Button } from "@mui/material";
import { Link } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Typography variant="h4" gutterBottom>
            Something went wrong.
          </Typography>
          <Typography variant="body1">
            We are sorry for the inconvenience. Please try again later.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/">
            Go to Home
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
